// extracted by mini-css-extract-plugin
module.exports = {"block":"index_block_2j5WE","label":"index_label_LqD3y","item":"index_item_271LE","itemTitle":"index_itemTitle_3CwS1"};